let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eSmn9")).then(() => parcelRequire('88yes'));